import { render } from "./PaymentComponent.vue?vue&type=template&id=bda9bf46"
import script from "./PaymentComponent.vue?vue&type=script&lang=js"
export * from "./PaymentComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/pos/PaymentComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bda9bf46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bda9bf46', __exports__)) {
    api.reload('bda9bf46', __exports__)
  }
  
  module.hot.accept("./PaymentComponent.vue?vue&type=template&id=bda9bf46", () => {
    api.rerender('bda9bf46', render)
  })

}


export default __exports__